<style scoped>
@import "https://fonts.googleapis.com/icon?family=Material+Icons";
@import "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined";

::placeholder {
  color: #fff !important;
  opacity: 1; /* Firefox */
}
.logo-placeholder {
  box-shadow: none !important;
}
.sshi-icon {
  padding: 0.5rem;
  max-width: 120px;
  max-height: 120px;
  width: auto;
  height: auto;
}
.sshi-logo {
  padding: 0.5rem;
  max-width: 80px;
  max-height: 80px;
  width: auto;
  height: auto;
}

.sshi-logo2 {
  margin: 0.25rem;
  border-radius: 50% !important;
  /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px; */
}

.sshi-logo3 {
  margin-left: 4rem;
  margin-right: 4rem;
  border-radius: 50% !important;
  /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px; */
}

.sshi-banner {
  margin-bottom: 0px;
  padding-top: 5em;
  background-image: url("/img/sshi/bg-scenery.webp");
  text-align: center;
  min-height: 25em;
}
.sshi-text {
  color: #fff !important;
}
.yellow-line {
  margin-left: 30%;
  margin-right: 30%;
  background-color: #ffdf12;
  height: 5px;
  border-radius: 20px;
}
.overlap-header {
  margin-top: -10em;
}
.slide-root {
  margin-top: -7em;
  padding-left: 7em;
  padding-right: 7em;
}
.slide-bag {
  /* margin-left: 1em;
  margin-right: 1em; */
  /* max-width: 200px; */
  border-radius: 1em;
  padding: 0em;
  background-color: white;
  /* max-height: 250px; */
  color: rgb(0, 60, 128);
}
.slide-arrow {
  background-color: #ffff;
  border-radius: 100%;
  padding-top: 1.2em;
  padding-bottom: 2.2em;
  color: rgb(0, 147, 221);
}
</style>
<template>
  <b-container
    fluid
    style="
      width: 100%;
      padding-bottom: 5%;
      font-family: 'Inter', 'sans-serif' !important;
      padding-left: 0px;
      padding-right: 0px;
    "
  >
    <b-jumbotron class="sshi-banner text-center">
      <h1 class="sshi-text" style="margin-bottom: 0px !important">
        Sistem Statistik Hayati Indonesia
      </h1>
      <h3 style="color: #ebca60; margin-top: 0em">
        Pondasi Data Akurat untuk Masa Depan Indonesia
      </h3>
    </b-jumbotron>
    <b-row class="overlap-header ml-5 mr-5">
      <b-col class="ml-5 mr-5">
        <div
          style="
            background-color: white;
            padding: 3em 5em 3em 5em;
            border-radius: 1em;
            text-align: justify;
          "
        >
          <p>
            Sistem Statistik Hayati Indonesia (SSHI) adalah sebuah platform yang
            dibangun oleh Badan Pusat Statistik bekerja sama dengan Direktorat
            Jenderal Kependudukan dan Pencatatan Sipil, Kementrian Kesehatan,
            dan Kementerian Perencanaan Pembangunan Nasional/Bappenas untuk
            menyediakan statistik hayati berdasarkan pencatatan sipil di
            Indonesia. Statistik ini mencakup peristiwa penting dalam kehidupan,
            seperti kelahiran, kematian, pernikahan, perceraian, dan adopsi.
            Pada tahun ini, Indonesia fokus pada pencatatan kelahiran dan
            kematian, dua komponen penting yang menjadi landasan kebijakan
            pemerintah dalam perencanaan dan penganggaran di tingkat pusat dan
            daerah.
          </p>
          <p>
            Melalui Platform SSHI, Anda dapat memahami secara menyeluruh
            peristiwa-peristiwa penting yang teregistrasi di seluruh Indonesia.
            Data yang dihasilkan dari platform ini mendukung pembangunan
            berkelanjutan serta pembuatan kebijakan yang lebih baik dan berbasis
            bukti.
          </p>
          <h4 style="margin-bottom: 1em !important">
            Didukung Oleh Kebijakan Nasional
          </h4>
          <p>
            Platform ini dibangun berdasarkan amanat Peraturan Presiden No. 62
            Tahun 2019 tentang Strategi Nasional Percepatan Administrasi
            Kependudukan untuk Pengembangan Statistik Hayati (Stranas AKPSH).
            Tim Stranas AKPSH berkomitmen mempercepat proses integrasi data
            administrasi kependudukan serta menyediakan statistik hayati yang
            akurat, andal, dan berkualitas.
          </p>
          <h4 style="margin-bottom: 1em !important">
            Mengapa Statistik Hayati Penting?
          </h4>
          <p>
            Statistik hayati sangat krusial dalam memahami dinamika kependudukan
            Indonesia. Data ini membantu berbagai pihak dalam:
          </p>
          <ol>
            <li>
              Kelahiran: Mengidentifikasi tren pertumbuhan penduduk untuk
              mendukung perencanaan alokasi sumber daya nasional.
            </li>
            <li>
              Kematian: Menganalisis tingkat kematian untuk meningkatkan program
              kesehatan masyarakat.
            </li>
            <li>
              Pernikahan dan Perceraian: Memahami perubahan sosial yang
              berdampak pada kebijakan keluarga.
            </li>
            <li>
              Adopsi: Memperkuat kebijakan kesejahteraan anak di Indonesia.
            </li>
          </ol>
          <p>
            Dengan data yang terus diperbarui secara berkala, platform SSHI
            memberikan wawasan komprehensif yang dibutuhkan oleh pembuat
            kebijakan, peneliti, dan masyarakat umum untuk pengambilan keputusan
            yang lebih baik dan tepat sasaran.
          </p>

          <hr />
          <p style="margin-top: 1em; text-align: center">
            SSHI merupakan
            <strong>hasil kolaborasi antara</strong>
          </p>
          <div class="d-flex justify-content-center">
            <div class="sshi-logo2">
              <b-img
                class="sshi-logo"
                src="/img/sshi/bps.png"
                alt="Badan Pusat Statistik"
              ></b-img>
            </div>
            <div class="sshi-logo2">
              <b-img
                class="sshi-logo"
                src="/img/sshi/kemendagri.png"
                alt="Badan Pusat Statistik"
              ></b-img>
            </div>
            <div class="sshi-logo2">
              <b-img
                class="sshi-logo"
                src="/img/sshi/kemenppn.png"
                alt="Badan Pusat Statistik"
              ></b-img>
            </div>
            <div class="sshi-logo2">
              <b-img
                class="sshi-logo"
                src="/img/sshi/kemenkes.png"
                alt="Badan Pusat Statistik"
              ></b-img>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="ml-5 mr-5 mt-5 mb-0">
      <b-col class="ml-5 mr-5" style="text-align: left">
        <h2>Sejarah dan Komitmen Kami</h2>
      </b-col>
    </b-row>

    <b-row class="ml-5 mr-5">
      <b-col class="ml-5 mr-5">
        <div
          style="
            background-color: white;
            padding: 3em 5em 3em 5em;
            border-radius: 1em;
            text-align: justify;
          "
        >
          <p>
            Platform SSHI lahir dari inisiatif nasional dalam memperkuat
            administrasi kependudukan di Indonesia. Ini sejalan dengan Rencana
            Pembangunan Jangka Menengah Nasional (RPJMN) 2020-2024 dan mendukung
            target Sustainable Development Goals (SDGs) 16.9, yaitu memastikan
            identitas legal bagi semua warga, termasuk pencatatan kelahiran,
            sebelum tahun 2030.
          </p>
          <b-row>
            <b-col cols="12">
              <h4 style="margin-bottom: 1em !important">
                Tim Produksi Statistik Hayati
              </h4>
              <p>
                Untuk memproduksi statistik hayati diperlukan berbagai dukungan
                dari lintas sektor, kementerian, dan lembaga. Pada poros
                utamanya terdapat Badan Pusat Statistik (BPS), Kementerian Dalam
                Negeri (Kemendagri), Kementerian PPN/Bappenas, Kementerian
                Kesehatan (Kemenkes). Pada masa yang akan datang, sumber
                statistik hayati akan dilengkapi dengan data dari Kementerian
                Agama (Kemenag), dan Mahkamah Agung (MA) dengan peranannya
                masing-masing.
              </p>
              <p>
                Laporan Statistik Hayati 2024 merupakan hasil kerja sama lintas
                sektor yang dipimpin oleh Badan Pusat Statistik (BPS). Sebagai
                ketua tim, BPS bertanggung jawab atas perencanaan, pengumpulan,
                pengolahan lanjuta, dan analisis data, serta penerbitan laporan.
                Didukung oleh Kementerian Dalam Negeri (Kemendagri) sebagai wali
                data, Kementerian PPN/Bappenas sebagai pengarah, dan Kementerian
                Kesehatan (Kemenkes) sebagai produsen data kelahiran dan
                kematian, BPS memastikan statistik hayati yang dihasilkan
                berkualitas dan relevan untuk memenuhi Regional Komitmen Asia
                Pasifik dalam CRVS.
              </p>
              <h4 style="margin-bottom: 1em !important">
                Data Terintegrasi dan Terpercaya
              </h4>
              <p>
                Kami mengumpulkan data dari berbagai sumber, termasuk sensus dan
                survei dari BPS, data administrasi kependudukan dari Ditjen
                Dukcapil, serta kontribusi dari kementerian dan lembaga terkait
                lainnya. Validitas data terjamin melalui koordinasi yang erat
                dengan Kementerian Dalam Negeri dan dukungan dari tim ahli di
                BPS. Selain itu, tim pendukung kami tersebar di 13 direktorat
                dari 8 kementerian/lembaga.
              </p>
            </b-col>
          </b-row>
          <h6 class="text-center" style="margin-bottom: 1em !important">
            Dengan Platform SSHI, kami menyediakan
          </h6>
          <b-row class="text-center">
            <b-col cols="4">
              <b-img
                url=""
                class="sshi-icon"
                src="/img/sshi/info-icon.svg"
                alt="Illustrations by Storyset"
              ></b-img>
              <p class="text-bold">Informasi Detail SSHI</p>
            </b-col>
            <b-col cols="4">
              <b-img
                class="sshi-icon"
                src="/img/sshi/visual-icon.svg"
                alt="Illustrations by Storyset"
              ></b-img>
              <p class="text-bold">Indikator Interaktif dan Lengkap</p>
            </b-col>
            <b-col cols="4">
              <b-img
                class="sshi-icon"
                src="/img/sshi/report-icon.svg"
                alt="Illustrations by Storyset"
              ></b-img>
              <p class="text-bold">Laporan yang Mudah Diakses</p>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
// import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

export default {
  name: "sshi-index",
  data() {
    return {
      ceklogin: false,
    };
  },
  // components: { VueperSlides, VueperSlide },
  created() {},
  mounted() {
    this.cekLogin();
  },
  setup() {},
  methods: {
    cekLogin() {
      let status = JSON.parse(localStorage.getItem("vuex"));
      if (status.auth.status == 0 || status == "") {
        this.ceklogin = true;
      }
      console.log(status);
    },
    keLogin() {
      window.location.href = "/login";
    },
  },
};
</script>

